import {htmlEntitiesEncode} from "../../src-common/utils/s2k-html-encode";
import {STK_STRING_UNKNOWN} from "../../src-common/constants";

/**
 * To return all child nodes of a given string of html
 * @param {string} innerHTML
 * @return {HTMLDivElement} Child nodes of a given string of html
 */
const createTemplate = (innerHTML) => {
    const template = document.createElement("template");
    template.innerHTML = innerHTML.trim();
    return template.content.childNodes;
};

/**
 * Create the metadata part (title and author) of the preview page
 * @param {{ title: string, author: string, url: string, date: string, source: string, htmlContent: string}} documentMetadata
 * @return {HTMLDivElement} Child div nodes content metadata part (title and author)
 */
const metadataTemplate = (documentMetadata) => {
    let title = htmlEntitiesEncode(documentMetadata.title || documentMetadata.source || STK_STRING_UNKNOWN);
    let author = htmlEntitiesEncode(documentMetadata.author || "");
    let date = documentMetadata.date;
    return createTemplate(`
        <header>
            <!-- Title input -->
            <div id="s2k-preview-title-section">
                <span class="s2k-preview-input-description" s2k-string="previewInputTitleDes" aria-hidden="true"></span>
                <div id="s2k-preview-title-container"> 
                    <input type="text" id="s2k-preview-title" class="s2k-preview-input" value="${title}" s2k-aria="A11yPreviewTitle">
                    <div class="s2k-preview-input-edit-icon"></div>
                </div>
                <div id="s2k-preview-title-length-alert" class="s2k-preview-input-inline-alert s2k-hide">
                    <div class="s2k-preview-input-inline-alert-icon"></div>
                    <div class="s2k-preview-input-inline-alert-text"></div>
                </div>
            </div>
            <!-- Other info -->
            <div id="s2k-preview-author-section">
                <span class="s2k-preview-input-description" s2k-string="previewInputAuthorDes" aria-hidden="true"></span>
                <div id="s2k-preview-byline">
                    <!-- Author input -->
                    <div id="s2k-preview-author-container"> 
                        <input type="text" id="s2k-preview-byline-author" class="s2k-preview-input" value="${author.replaceAll(/"/g, '&quot;')}" s2k-aria="A11yPreviewAuthor">
                        <div class="s2k-preview-input-edit-icon"></div>
                    </div>
                    <!-- Date input -->
                    ${date ? `
                                <time id="s2k-preview-timestamp" datetime="${htmlEntitiesEncode(date)}">${htmlEntitiesEncode(date)}</time>
                            ` : ""}
                </div>
            </div>
            <div id="s2k-preview-author-length-alert" class="s2k-preview-input-inline-alert s2k-hide">
                <div class="s2k-preview-input-inline-alert-icon"></div>
                <div class="s2k-preview-input-inline-alert-text"></div>
            </div>
            <!-- Devide line -->
            <hr>
        </header>
    `);
};

/**
 * Create the content part of the preview page
 * @param {string} htmlContent The string of the content of the document that extracted by web extraction algorithm
 * @return {HTMLDivElement} Child div nodes of content part
 */
const contentTemplate = (htmlContent) => {
    return createTemplate(`<section>${htmlContent}</section>`);
};


/**
 * Create the footer part (origin web page url) of the preview page
 * @param {string} source The string of the original url of the web page currently preview
 * @return {HTMLDivElement} Child div nodes of footer part
 */
const footerTemplate = (source) => {
    const shortSource = source.length > 140 ? `${source.substring(0, 137)}...` : source;

    return createTemplate(`
        <footer>
            <hr>
            <div id="s2k-preview-footer-text">Source: <a href="${source}">${shortSource}</a></div>
        </footer>
    `);
};

export {metadataTemplate, contentTemplate, footerTemplate};